// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-SX2h9","controls__wrapper":"controls__wrapper-1iyMz","leg":"leg-2dseS"};